// 深拷贝
function deepCopy (obj) {
  if (!obj) return
  var newObj
  try {
    newObj = obj.constructor && obj.constructor === Array ? [] : {}
    newObj.constructor = obj.constructor
  } catch (e) {
    newObj = []
  }
  if (typeof obj !== 'object') {
    return
  } else {
    for (var prop in obj) {
      if (!obj[prop] || obj[prop].constructor === RegExp || obj[prop].constructor === Date) {
        newObj[prop] = obj[prop]
      } else if (typeof obj[prop] === 'object') {
        // 递归
        newObj[prop] = deepCopy(obj[prop])
      } else {
        newObj[prop] = obj[prop]
      }
    }
  }
  return newObj
}

// 随机id
function generateUgid () {
  let d = new Date().getTime()
  let uuid = 'axxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    let r = ((d + Math.random() * 16) % 16) | 0
    d = Math.floor(d / 16)
    return (c === 'x' ? r : (r & 0x7) | 0x8).toString(16)
  })
  return uuid
}

// 中国标准时间格式化为 xxxx-xx-xx xx:xx:xx
function dateFormat (d) {
  // return d = d.getFullYear() + '-' + ((d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1)) + '-' + (d.getDate() < 10 ? '0' + d.getDate() : d.getDate());
  return d.getFullYear() + '-' + ((d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1)) + '-' + (d.getDate() < 10 ? '0' + d.getDate() : d.getDate()) + ' ' + (d.getHours() < 10 ? '0' + d.getHours() : d.getHours()) + ':' + (d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes()) + ':' + (d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds())
}

// 处理表格里的日期 xxxx-xx-xxTxx:xx:xx00000 格式为 xxxx-xx-xx xx:xx:xx
function tableDateFormat (date) {
  return dateFormat(new Date(date))
}

// 处理UNIX()时间戳 格式为 xxxx-xx-xx xx:xx:xx
function unixDateFormat (date) {
  if (date === 0) {
    return null
  } else {
    var unixTimestamp = new Date(date * 1000)
    return dateFormat(unixTimestamp)
  }
}
function unixMilliDateFormat (date) {
  if (date === 0) {
    return null
  } else {
    var d = new Date(date)
    return d.getFullYear() + '-' + ((d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1)) + '-' + (d.getDate() < 10 ? '0' + d.getDate() : d.getDate()) + ' ' + (d.getHours() < 10 ? '0' + d.getHours() : d.getHours()) + ':' + (d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes()) + ':' + (d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds()) + ' ' + d.getMilliseconds()
  }
}
// 递归获取树 [{id: 1, parentId: null, name: '11'}, {id: 2, parentId: null, name: '22'}, {id: 3, parentId: 1, name: '33'}, {id: 4, parentId: 1, name: '44'}]
function getTreeData (data, idField, parentField, childField, oldNodeName, newNodeName) {
  // 删除 所有 children,以防止多次调用
  if (!childField) childField = 'childData'
  data.forEach(function (item) {
    delete item[childField]
  })

  // 将数据存储为 以 id 为 KEY 的 map 索引数据列
  var map = {}
  data.forEach(function (item) {
    map[item[idField]] = item
  })
  //        console.log(map)
  var val = []
  data.forEach(function (item) {
    // 以当前遍历项，的pid,去map对象中找到索引的id
    var parent = map[item[parentField]]
    // 如果找到索引，那么说明此项不在顶级当中,那么需要把此项添加到，他对应的父级中
    if (parent) {
      if (!parent[childField]) parent[childField] = []
      // item[newNodeName] = item[oldNodeName] 如果需要函数定制节点名称 可放开注释
      parent[childField].push(item)
    } else {
      // 如果没有在map中找到对应的索引ID,那么直接把 当前的item添加到 val结果集中，作为顶级
      // item[newNodeName] = item[oldNodeName] 如果需要函数定制节点名称 可放开注释
      val.push(item)
    }
  })
  return val
}

// ===== 调度规则的时区换算（用户操作边界）=====
// 约定：后端（含调度器）一律以 UTC 存储与计算，本组函数负责在"用户操作"时完成
// 本地时间 ↔ UTC 的互转：提交前转 UTC，展示/回填时转回本地。
// 因此这里不出现任何硬编码时区，海外用户也走同一套逻辑（依据浏览器实际偏移）。
//
// 「定时」规则的字段是拆开的钟表值（hour/minute/second/weekday/day），换算可能跨天：
// 东八区下"每周一 04:00"对应 UTC 的"周日 20:00"，星期与日期都要跟着回退，
// 所以统一按分钟换算再按需回退星期/日期。
//
// 已知限制：
// 1) 有夏令时的地区按"当前偏移"换算，固定为 UTC 的规则在夏令时切换后会偏 1 小时；
// 2) 「每月 1 日 + 08:00 之前」的本地时间对应 UTC 的上月最后一天，cron 无法表达，提交时会被拦下。

function pad2 (n) {
  return (n < 10 ? '0' : '') + n
}

// 本地 → UTC 的分钟修正量（东八区为 -480）
function tzOffsetMinutes () {
  return new Date().getTimezoneOffset()
}

// 本地钟表值 -> UTC。timing_type 为 hour 时只用到分/秒，与时区无关，原样返回。
function timingToUTC (cfg) {
  var c = Object.assign({}, cfg)
  var type = c.timing_type
  if (type === 'hour') {
    return c
  }
  var total = Number(c.hour || 0) * 60 + Number(c.minute || 0) + tzOffsetMinutes()
  var dayShift = Math.floor(total / 1440)
  var norm = ((total % 1440) + 1440) % 1440
  c.hour = Math.floor(norm / 60)
  c.minute = norm % 60
  if (type === 'week') {
    c.weekday = (((Number(c.weekday || 0) + dayShift) % 7) + 7) % 7
  } else if (type === 'month') {
    c.day = Number(c.day || 1) + dayShift
    if (c.day < 1) {
      throw new Error('该日期与时间的组合无法用 UTC 表达（会落到上月最后一天），请把日期改为 2~31 日，或把时间改到 08:00 之后')
    }
  }
  return c
}

// UTC 钟表值 -> 本地（展示/回填用）
function timingToLocal (cfg) {
  var c = Object.assign({}, cfg)
  var type = c.timing_type
  if (type === 'hour') {
    return c
  }
  var total = Number(c.hour || 0) * 60 + Number(c.minute || 0) - tzOffsetMinutes()
  var dayShift = Math.floor(total / 1440)
  var norm = ((total % 1440) + 1440) % 1440
  c.hour = Math.floor(norm / 60)
  c.minute = norm % 60
  if (type === 'week') {
    c.weekday = (((Number(c.weekday || 0) + dayShift) % 7) + 7) % 7
  } else if (type === 'month') {
    c.day = Number(c.day || 1) + dayShift
  }
  return c
}

// "HH:mm" 整体平移 delta 分钟（用于有效时段的起止）
function shiftTimeOfDay (hhmm, deltaMinutes) {
  var parts = String(hhmm || '').split(':')
  var h = Number(parts[0])
  var m = Number(parts[1])
  if (isNaN(h) || isNaN(m)) {
    return hhmm
  }
  var norm = (((h * 60 + m + deltaMinutes) % 1440) + 1440) % 1440
  return pad2(Math.floor(norm / 60)) + ':' + pad2(norm % 60)
}

function timeOfDayToUTC (hhmm) {
  return shiftTimeOfDay(hhmm, tzOffsetMinutes())
}

function timeOfDayToLocal (hhmm) {
  return shiftTimeOfDay(hhmm, -tzOffsetMinutes())
}

// 统一成带 Z 的 RFC3339 UTC 串（后端按 RFC3339 解析）
function toRFC3339UTC (value) {
  if (!value) {
    return ''
  }
  var d = value instanceof Date ? value : new Date(value)
  if (isNaN(d.getTime())) {
    return ''
  }
  return d.toISOString()
}

// schedule_config：本地 -> UTC，提交前调用。无法表达的组合会抛出带提示语的 Error。
function scheduleConfigToUTC (cfg) {
  var c = timingToUTC(cfg)
  if (c.time_range) {
    c.start_time = timeOfDayToUTC(c.start_time)
    c.end_time = timeOfDayToUTC(c.end_time)
  }
  if (c.fre_start) {
    c.fre_start = toRFC3339UTC(c.fre_start)
  }
  c.tz = 'utc'
  return c
}

// schedule_config：UTC -> 本地，展示/回填前调用。
// 缺少 tz 标记说明是 UTC 化改造之前写入的存量数据，其字段仍是本地钟表值，
// 原样返回即可（否则会被反向换算成 +8 小时，用户看到错误时间）。
function scheduleConfigToLocal (cfg) {
  if (!cfg || cfg.tz !== 'utc') {
    return cfg
  }
  var c = timingToLocal(cfg)
  if (c.time_range) {
    c.start_time = timeOfDayToLocal(c.start_time)
    c.end_time = timeOfDayToLocal(c.end_time)
  }
  return c
}

const commonFun = {
  deepCopy,
  generateUgid,
  dateFormat,
  tableDateFormat,
  getTreeData,
  unixDateFormat,
  unixMilliDateFormat,
  timingToUTC,
  timingToLocal,
  timeOfDayToUTC,
  timeOfDayToLocal,
  toRFC3339UTC,
  scheduleConfigToUTC,
  scheduleConfigToLocal
}

export default commonFun



// WEBPACK FOOTER //
// ./src/common/function.js